"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _spauiButton = _interopRequireDefault(require("@tencent/spaui-button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
var _default = function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cancelButton = props.cancelButton,
      cancelBsStyle = props.cancelBsStyle,
      onCancel = props.onCancel,
      cancelLabel = props.cancelLabel,
      submitButton = props.submitButton,
      submitBsStyle = props.submitBsStyle,
      onSubmit = props.onSubmit,
      disabled = props.disabled,
      submitLabel = props.submitLabel;
  var result = [];

  if (cancelButton) {
    result.push(_react["default"].createElement(_spauiButton["default"], {
      key: "cancelbutton",
      bsStyle: cancelBsStyle,
      onClick: onCancel
    }, cancelLabel));
  }

  if (submitButton) {
    result.push(_react["default"].createElement(_spauiButton["default"], {
      key: "submitbutton",
      bsStyle: submitBsStyle,
      onClick: onSubmit,
      disabled: disabled
    }, submitLabel));
  }

  return _react["default"].createElement("div", {
    className: "modal-footer-right-inner"
  }, result);
};

exports["default"] = _default;